// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function EyeSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M7.11 3.991A1.5 1.5 0 1 0 4.89 6.01l2 2.206C2.584 11.082.715 15.197.625 15.391a1.51 1.51 0 0 0 0 1.219c.046.102 1.141 2.532 3.561 4.951C7.421 24.793 11.5 26.5 16 26.5a16.419 16.419 0 0 0 6.375-1.25l2.511 2.762a1.5 1.5 0 0 0 2.22-2.017L7.11 3.991ZM16 23.5c-3.699 0-6.934-1.341-9.614-3.985A16.335 16.335 0 0 1 3.69 16c.659-1.164 2.349-3.738 5.25-5.536l11.261 12.388A13.669 13.669 0 0 1 16 23.5Zm15.375-6.89c-.045.101-1.125 2.5-3.5 4.895a1.5 1.5 0 1 1-2.125-2.113A16.311 16.311 0 0 0 28.31 16a16.297 16.297 0 0 0-2.696-3.515C22.933 9.841 19.699 8.5 16 8.5c-.419 0-.838.018-1.25.053a1.5 1.5 0 1 1-.25-2.99c.491-.042 1-.063 1.5-.063 4.5 0 8.579 1.709 11.811 4.94 2.419 2.419 3.514 4.85 3.56 4.951a1.51 1.51 0 0 1 .004 1.219Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
